import React, { useState } from "react";
import "./style.css";
import { Box, Button, Center, Container, Tabs } from "@mantine/core";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useSelector } from "react-redux";
import { SkypointInvoiceSetting } from "./SkypointInvoiceSetting";
import SkypointBillingInvoicesDashboard from "../../../components/SkypointBillingInvoices/SkypointBillingInvoicesDashboard";
import SkypointCustomers from "../../../components/SkypointBillingInvoices/SkypointCustomers";
import SkypointPayments from "../../../components/SkypointBillingInvoices/SkypointPayments";
import SkypointRecurringInvoices from "../../../components/SkypointBillingInvoices/SkypointBillingInvoicesDashboard/SkypointRecurringInvoices";
import SkypointReports from "../../../components/SkypointBillingInvoices/SkypointReports";
import SkypointSettingDrawer from "../../../components/SkypointBillingInvoices/SkypointInvoiceSetting/SkypointSettingDrawer";
import SkypointNewInvoices from "../../../components/SkypointBillingInvoices/SkypointBillingInvoicesDashboard/SkypointNewInvoice";

const SkypointBillingInvoices = () => {
  const [state, setState] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Dashboard");
  const [drawerOpened, setDrawerOpened] = useState(false);
  const closeDrawer = () => setDrawerOpened(false);
  const { profile } = useSelector((state) => state?.profile);

  const renderTabContent = () => {
    switch (selectedTab) {
      case "Dashboard":
        return <SkypointBillingInvoicesDashboard setState={setState} />;
      case "Customer":
        return <SkypointCustomers setState={setState} />;
      case "Payment":
        return <SkypointPayments setState={setState} />;
      case "recurringInvoices":
        return <SkypointRecurringInvoices setState={setState} />;
      case "reports":
        return <SkypointReports />;
      case "setting":
        return <SkypointInvoiceSetting />;
      default:
        return <SkypointBillingInvoicesDashboard setState={setState} />;
    }
  };

  return (
    <Box fluid className="content" >
      <AppNavbar title="Invoices" profile={profile} />

      <Box className="mainbillingInvoicecontainer">
        {/* tabs work */}

        <Box className="tabs">
          <Tabs
            style={{ marginTop: "2px", display:'flex', alignItems:'center' }}
            defaultValue="Dashboard"
            value={selectedTab}
            onTabChange={setSelectedTab}
          >
            <Tabs.List>
              <Tabs.Tab className="tabbtn" value="Dashboard">
                Dashboard
              </Tabs.Tab>
              {/* <Tabs.Tab className="tabbtn" value="Customer">
                Customer
              </Tabs.Tab> */}
              <Tabs.Tab className="tabbtn" value="Payment">
                Payment
              </Tabs.Tab>
              <Tabs.Tab className="tabbtn" value="recurringInvoices">
                Recurring Invoices
              </Tabs.Tab>
              <Tabs.Tab className="tabbtn" value="reports">
                Reports
              </Tabs.Tab>
              <Tabs.Tab className="tabbtn" value="setting">
                Settings
              </Tabs.Tab>
            </Tabs.List>
            {/* <Box 
              className="tabbtn"
              onClick={() => {
                setDrawerOpened(true);
              }}
              style={{padding:'0 1rem'}}
            >
              Setting
            </Box> */}
          </Tabs>
          
          {/* <Box className="imgflex">
            <Button
              // onClick={nextbtn}
              // className={classes.flexend}
              // onClick={nextbtn}
              onClick={() => {
                setState(true);
              }}
              variant="filled"
              type="submit"
              c={"#000"}
              radius={"md"}
              size="md"
              color="yellow"
            >
              New Invoice
            </Button>
            <img
              onClick={() => {
                setDrawerOpened(true);
              }}
              className="img"
              width={24}
              height={24}
              src="/assets/images/component.png"
              alt="home"
            />
          </Box> */}
          <SkypointNewInvoices state={state} setState={setState} />
        </Box>

        {/* <Dashboard/> */}

        {renderTabContent()}
      </Box>
      <Center>
        <SkypointSettingDrawer
          title="Settings"
          opened={drawerOpened}
          close={closeDrawer}
          // claimData={claimData}
          // patientsdata={patientsdata}
        />
      </Center>
    </Box>
  );
};

export default SkypointBillingInvoices;